import { InputBase, Stack } from '@mui/material'
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium'
import { ChangeEvent } from 'react'
import { checkAndStopCellEditMode } from './utils/CheckAndSetMode'

interface TextInputCellProps extends GridRenderEditCellParams {
  isFirst?: boolean
}

export const TextInputCell = ({ id, value, field, placeholder, isFirst }: TextInputCellProps): React.ReactElement => {
  const apiRef = useGridApiContext()

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    void apiRef.current?.setEditCellValue({ id, field, value: e.target.value })
  }

  return (
    <Stack sx={{ flexGrow: 1, display: 'flex', paddingLeft: isFirst ? 5 : 3 }} onClick={(e) => e.preventDefault()}>
      <InputBase
        placeholder={placeholder}
        value={value}
        onChange={(e) => handleChange(e)}
        onBlur={() => checkAndStopCellEditMode(apiRef, id, field)}
      />
    </Stack>
  )
}
